import { render, staticRenderFns } from "./403.vue?vue&type=template&id=d9a61a3a"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a61a3a')) {
      api.createRecord('d9a61a3a', component.options)
    } else {
      api.reload('d9a61a3a', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=d9a61a3a", function () {
      api.rerender('d9a61a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/403.vue"
export default component.exports